import '../App.css';
import AboutUs from '../components/AboutUs';
import Carrousel from '../components/Carrousel';
import Clients from '../components/Clients';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Products from '../components/Products';
import Services from '../components/Services';

export function Landing(props) {
    return (
        <div id='start' className='font-open-sans'>
            <Navbar isLargeScreen={props.isLargeScreen}/>
            <Carrousel/>
            <div className='information-section navbar-target'>
                <AboutUs isLargeScreen={props.isLargeScreen}/>
                <Services isLargeScreen={props.isLargeScreen}/>
                <Products isLargeScreen={props.isLargeScreen}/>
                <Clients/>
                <ContactUs isLargeScreen={props.isLargeScreen}/>
                <Footer/>
            </div>
        </div>
    );
  }